import "./utils/schemaUtils";
import "./i18n";
import { createRoot } from "react-dom/client";

import App from "./app";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe
const root = createRoot(document.getElementById("root")!);
root.render(<App />);
